import Profile from './profile-page';
import ProfileCurrencyOptions from './profile-currency-options';
import ProfileChangeLanguage from './profile-language-options';
import ConsolidationSetup from './consolidation-setup/consolidation-setup';
import NotificationSettings from './notification-setting/notification-setting';
import ClientFeedback from './client-feedback/client-feedback';
import TermsCondition from './terms-condition/terms-condition';
import Security from './security';
import Portfolio from './portfolio';
import DocSignSubscription from './docsign-subscription/docsign-subscription';
import ManageDevices from './manage-devices/manage-devices';
import UserBPList from './manage-contact-details';
import ManageContactDetails from './manage-contact-details/manage-contact-details';
import HrmwForm from './manage-contact-details/hrmw-form';
import AddContactDetails from './manage-contact-details/add-contact-details';
import AmendContactDetails from './manage-contact-details/amend-contact-details';
import PaperlessSettings from './paperless-settings/paperless-settings';
import ManageSepaTransactionLimit from './sepa-transaction-limit/sepa-transaction-limit';
import SepaTransactionLimitSuccess from './sepa-transaction-limit/sepa-transaction-limit-success';

export default {
  Profile,
  Portfolio,
  ProfileCurrencyOptions,
  ProfileChangeLanguage,
  ConsolidationSetup,
  NotificationSettings,
  ClientFeedback,
  TermsCondition,
  Security,
  DocSignSubscription,
  ManageDevices,
  UserBPList,
  ManageContactDetails,
  HrmwForm,
  AddContactDetails,
  AmendContactDetails,
  PaperlessSettings,
  ManageSepaTransactionLimit,
  SepaTransactionLimitSuccess
};
